import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { uerpWorkflowSteps } from "../uerpModulesData";

const stepIcons = [
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 3L2 8l10 5 10-5-10-5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M6 11v5c0 2 2.5 4 6 4s6-2 6-4v-5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="4" y="5" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <path d="M8 3v4M16 3v4M4 10h16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
      <path d="M12 7v5l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <rect x="4" y="4" width="16" height="16" rx="3" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M4 18V8M4 18h16M8 14V11M12 14V6M16 14V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 3v12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M8 11l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M5 21h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
];

const UerpHowItWorksSection: React.FC = () => (
  <section className="wdev-tech" aria-labelledby="uerp-how-title">
    <div className="container">
      <AnimatedSection className="wdev-section-head wdev-section-head--center">
        <h2 id="uerp-how-title" className="wdev-section-head__title">
          How Our College ERP Works
        </h2>
        <p className="uerp-section-lead">
          A structured academic lifecycle from admission through graduation — digitised for
          universities, institutions, and autonomous colleges.
        </p>
      </AnimatedSection>

      <div className="wdev-process__timeline uerp-process-timeline">
        <div className="wdev-process__line" aria-hidden="true" />
        {uerpWorkflowSteps.map((step, index) => (
          <motion.div
            key={step.title}
            className="wdev-process__step"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.08 }}
          >
            <div className="wdev-process__badge">{String(index + 1).padStart(2, "0")}</div>
            <div className="wdev-process__card">
              <div className="wdev-process__icon">{stepIcons[index]}</div>
              <h3 className="wdev-process__title">{step.title}</h3>
              <p className="wdev-process__desc">{step.text}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default UerpHowItWorksSection;
